import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { hasAuthToken } from '@/utils';

export function NotFoundPage() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!hasAuthToken()) {
      navigate({ to: '/login', replace: true });
    }
  }, [navigate]);

  if (!hasAuthToken()) return null;

  return (
    <div className="flex flex-1 flex-col items-center justify-center py-24 text-center">
      <p className="text-8xl font-bold text-primary-s500">404</p>
      <h1 className="mt-4 text-2xl font-semibold text-black">Page not found</h1>
      <p className="mt-2 text-base text-lightGray">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <button
        type="button"
        onClick={() => navigate({ to: '/' })}
        className="mt-8 rounded-full bg-primary-s500 px-6 py-2.5 text-sm font-medium text-white hover:bg-blue-700 transition-colors"
      >
        Back to Home
      </button>
    </div>
  );
}
